<template>
    <qid-input></qid-input>
</template>

<script>
    import QidInput from './qid-input.vue';

    export default {
        components : { QidInput }
    }
</script>
